import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Box, IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuIcon from '@mui/icons-material/Menu'; 
import { NavLink, useNavigate, useLocation, Link } from 'react-router-dom';
import { dataDashboards } from '../data/data_dashboards';
import { useAuth } from '../auth/auth_context'; 
import getDashboardIcon from '../components/DashboardIcon';

function LeftNav({ isOpen, toggleNav, sizingNav }) {
  const [dashboards, setDashboards] = useState([]);
  
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthReady } = useAuth();
  
  useEffect(() => {
    async function fetchDashboards() {
      if (isAuthReady) {
        const loadedDashboards = await dataDashboards.loadUserDashboards();
        setDashboards(loadedDashboards);
      }
    }
    fetchDashboards();
  }, [isAuthReady]);

  const handleNavigation = (path) => {
    if (location.pathname === path) {
      navigate(0);
    }
  };

  const listItemTextStyles = {
    visibility: isOpen ? 'visible' : 'hidden',
    width: isOpen ? 'auto' : 0,
    transition: 'width 0.3s, visibility 0.3s',
    minWidth: 0,
    margin: 0,
    padding: 0,
    position: 'absolute',
    left: '56px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 56px)',
  };

  const listItemStyles = {
    padding: '8px 16px',
    height: '48px',
    minHeight: '48px',
    position: 'relative',
    '& .MuiListItemIcon-root': {
      minWidth: '40px',
      marginRight: '16px',
    },
    '& .MuiListItemText-root': {
      margin: 0,
      padding: 0,
    },
  };

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: isOpen ? sizingNav.width : sizingNav.widthClosed, 
    transition: 'width 0.3s',
    position: 'relative',
  };

  const mainListStyles = {
    flex: 1,
    overflowY: 'auto',
    padding: 0,
    margin: 0,
    '& .MuiListItem-root': {
      height: '48px',
      minHeight: '48px',
    },
  };

  const bottomSectionStyles = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'inherit',
  };

  return (
    <Box sx={containerStyles}>
      <IconButton onClick={toggleNav} sx={{ margin: '8px', justifyContent: 'flex-end', alignSelf: 'flex-start' }}>
        <MenuIcon />
      </IconButton>
      <List sx={mainListStyles}>
        <ListItem button component={NavLink} to="/home" exact="true" sx={listItemStyles}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" sx={listItemTextStyles} />
        </ListItem>
        
        {dashboards.map(dashboard => (
          <ListItem 
            button 
            component={NavLink} 
            to={`/dashboard/${dashboard.id}`} 
            key={dashboard.id} 
            onClick={() => handleNavigation(`/dashboard/${dashboard.id}`)}
            sx={listItemStyles}
          >
            <ListItemIcon>
              {getDashboardIcon(dashboard.icon)}
            </ListItemIcon>
            <ListItemText primary={dashboard.dashboard_name} sx={listItemTextStyles} />
          </ListItem>
        ))}
      </List>
      <Box sx={bottomSectionStyles}>
        <Divider />
        <List sx={{ padding: 0, margin: 0 }}>
          <ListItem button component={Link} to="/settings" sx={listItemStyles}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" sx={listItemTextStyles} />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}

export default LeftNav;
